const {Component} = require("react");
const PropTypes = require("prop-types");
const router = require("app/services/router");
const Product = require("app/components/widgets/search/Product");
const Post = require("app/components/widgets/search/Post");
const axios = require("axios");
const Link = require("app/components/mixins/Link");
const lazyload = require("app/frontend/lazy-load");
const env = require("app/services/env");
const googleAnalytics = require('app/services/googleAnalytics');
const Trans = require('app/components/trans/Trans')

class SearchManager extends Component {

	static get propTypes() {
		return {
			query: PropTypes.string,
			items: PropTypes.object,
		};
	}

	static get defaultProps() {
		return {
			query: ""
		};
	}

	get groups() {
		return {
			products: {
				title: translate("Produkter"),
				accessor: "products",
				component: Product
			},

			posts: {
				title: translate("Blog"),
				accessor: "posts",
				component: Post
			}
		};
	}

	normalizeItems(items) {
		const groups = this.groups;
		let normalizedItems = {};

		Object.keys(groups).map(groupId => {
			normalizedItems[groupId] = items[groupId] || [];
		});

		return normalizedItems;
	}

	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			query: props.query,
			activeGroup: Object.keys(this.groups) [0],
			items: this.normalizeItems(props.items)
		};
	}

	get currentGroup() {
		return this.groups[this.state.activeGroup];
	}

	get currentItems() {
		return this.state.items[this.currentGroup.accessor];
	}

	get className() {
		let classList = ["search-manager"];

		if (this.state.loading) {
			classList.push("loading");
		}

		return classList.join(" ");
	}

	_groupTriggerListener = (groupId) => {
		return (e) => {
			e.preventDefault();
			this.setState({activeGroup: groupId});
		};
	};

	empty() {
		this.searchInput.value = "";
		this.performSearch("");
		return this;
	}

	performSearch(query) {
		this.setState({loading: true});

		axios.get(router.route("api.search.query", null, {q: encodeURIComponent(query)}))
			.then(response => {
				this.setState({
					loading: false,
					query: query,
					items: this.normalizeItems(response.data)
				}, () => {
					if (this.currentItems.length > 0) {
						lazyload.resolveLazyLoad(document.querySelectorAll('[lazy-load]'));
					}

					// New
					if (window.dataLayer && typeof window.dataLayer.push === 'function') {
					    window.dataLayer.push({
							search_string: this.state.query,
							content_type:  'product',
							content_ids:   this.state.items['products']
											   .map(i => i.google_product_id || null)
											   .filter(i => i),
						});
                    }

					// Old
					if(!env.debug() && typeof window.ga !== 'undefined') {
						googleAnalytics('config', 'UA-5570334-3', {
							'page_path': '/soegning?q=' + encodeURIComponent(query)
						});
                    }
				});
			});
	}

	_onSubmit = (e) => {
		e.preventDefault();
		const query = this.searchInput.value;
		this.performSearch(query);
	};

	focus() {
		if (this.searchInput) {
			this.searchInput.focus();
		}
	}

	renderInfo() {
		if (this.state.query.length === 0) {
			return;
		}

    const count   = this.currentItems.length
    const number  = count > 0 ? count : translate('ingen');
    const results = count === 1 ? translate('resultat') : translate('resultater');

		return (
			<div className="search-info">
				<div className="results-counter">
                  <Trans replace={{resultNumber: number, resultText: results, searchQuery: this.state.query}}>Vi fandt :resultNumber :resultText på søgningen :searchQuery</Trans>
				</div>
			</div>
		);
	}

	renderGroupTriggers() {
		const groups = this.groups;

		return Object.keys(groups).map(groupId => {
			const className = this.state.activeGroup === groupId ? "active" : "";

			return (
				<Link key={groupId} className={className} href="#"
					 onClick={this._groupTriggerListener(groupId)}>{groups[groupId].title}</Link>
			);
		});
	}

	renderItems(groupId) {
		const group = this.groups[groupId];
		const Item = group.component;

		return this.state.items[group.accessor].map(item => {
			return (
				<Item key={item.id} {...item}/>
			);
		});
	}

	renderGroups() {
		const groups = this.groups;

		return Object.keys(groups).map(groupId => {
			let classList = ["group"];

			if (this.state.activeGroup === groupId) {
				classList.push("active");
			}

			return (
				<div key={groupId} className={classList.join(" ")}>{this.renderItems(groupId)}</div>
			);
		});
	}

	render() {
		return (
			<div className={this.className}>
				<form className="search-input" onSubmit={this._onSubmit}>
					<input type="text" ref={el => this.searchInput = el} placeholder={ translate("Hvad søger du?") }/>
					<button type="submit">
						<div className={'sprite'} lazy-load={'true'} cssbg={router.url("img/icons/icons-black@2x.png")} ></div>
					</button>
				</form>
				<div className="search-header">
					{this.renderInfo()}
					<div className="group-triggers">{this.renderGroupTriggers()}</div>
				</div>
				<div className="search-body">{this.renderGroups()}</div>
			</div>
		);
	}

}

module.exports = SearchManager;
